<template>
  <div class="audit-config-content">
    <el-form class="form" :model="formData" label-position="top" ref="formRef" inline>
      <el-form-item label="省市区(县)" prop="location" class="w-p-100">
        <AreaCascader class="w-p-100" v-model="formData.location" checkStrictly :end-level="2" placeholder="请选择"></AreaCascader>
      </el-form-item>
      <el-form-item label="房源审核" class="w-p-100">
        <el-radio v-model="formData.houseReviewStatus" :label="1" size="large">审核</el-radio>
        <el-radio v-model="formData.houseReviewStatus" :label="2" size="large">不审核</el-radio>
      </el-form-item>
      <el-form-item label="服务费" class="w-p-100">
        <el-radio v-model="formData.serviceFeeStatus" :label="1" size="large">审核</el-radio>
        <el-radio v-model="formData.serviceFeeStatus" :label="2" size="large">不审核</el-radio>
      </el-form-item>
      <!-- <el-form-item label="经营者审核" class="w-p-50-d-10">
        <el-radio v-model="formData.managerReviewStatus" :label="1" size="large">审核</el-radio>
        <el-radio v-model="formData.managerReviewStatus" :label="2" size="large">不审核</el-radio>
      </el-form-item> -->
      <!-- <el-form-item label="防疫资料" class="w-p-50-d-10">
        <el-radio v-model="formData.healthUploadStatus" :label="1" size="large">需要</el-radio>
        <el-radio v-model="formData.healthUploadStatus" :label="2" size="large">不需要</el-radio>
      </el-form-item> -->
      <div class="bottom-btn">
        <el-button class="submit-btn" v-loading="btnLoading" @click="handleConfirm">确定</el-button>
        <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AreaCascader from '@/components/common/areaCascader'

export default {
  components: { AreaCascader },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    configInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      btnLoading: false,

      formData: {
        id: '',
        location: [],
        houseReviewStatus: 2,
        serviceFeeStatus: 2,
        managerReviewStatus: 2,
        healthUploadStatus: 2
      },
      provinces: [],
      cities: [],
      regions: [],
    }
  },
  created() {
    if (this.configInfo.id) {
      this.handleEditInit()
    }
  },
  watch: {
    show(val) {
      if (val) {
        if (this.configInfo.id) {
          this.handleEditInit()
        } else {
          this.formData = {
            id: '',
            location: [],
            houseReviewStatus: 2,
            serviceFeeStatus: 2,
            managerReviewStatus: 2,
            healthUploadStatus: 1
          }
        }
      }
    },
  },
  methods: {
    ...mapActions(['fetchData']),
    // 处理编辑弹框初始化
    handleEditInit() {
      for (let i in this.formData) {
        this.formData[i] = this.configInfo[i]
      }
      this.formData.location = [this.configInfo.province]
    },
    // 操作确认
    handleConfirm() {
      if (!this.formData.location[0]) {
        return this.$message.error('请选择省市区(县)！')
      }

      let url = 'SYSTEM.CONFIG.POST_SAVE_OR_UPDATE'
      let params = JSON.parse(JSON.stringify(this.formData))
      params.areaCode = params.location.pop()
      delete params.location
      if (!params.id) delete params.id

      this.btnLoading = true
      this.fetchData({ url, method: 'post', params, headers: { "Content-Type": "application/json" }, flag: true }).then((res) => {
        if (res.code == 200) {
          this.$message.success('成功！')
          this.$emit('success')
          this.handleCancel()
        } else {
          this.$message.error(res.msg || '操作失败！')
        }
      }).catch(err => {
        this.$message.error(err || '操作失败！')
      }).finally(() => {
        this.btnLoading = false
      })
    },
    // 取消
    handleCancel() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.form {
  justify-content: space-between;
  width: 100%;
  :deep(.el-form-item) {
    margin-right: 15px;
  }
  :deep(.el-cascader) {
    width: 100%;
  }
  .bottom-btn {
    margin-top: 20px;
    text-align: center;
    width: 100%;
  }
}
.w-p-50-d-10 {
  width: calc(~"50% - 15px");
}
</style>
